<div class="top-products">
  <div class="section-header">
    <h3 class="title">
      {{ "top-sold-tickets-active-event.title" | translate }}
    </h3>
    <a class="see-all" (click)="goToAllSoldTickets()">
      {{ "top-sold-tickets-active-event.see-all" | translate }}
    </a>
  </div>
  <div class="content">
    @if (tickets.length === 0 && !loading) {
    <div class="empty-container">
      <app-empty-state
        [title]="'top-sold-tickets-active-event.no-sold-tickets'"
        [subtitle]="'top-sold-tickets-active-event.no-sold-tickets-subtitle'"
        [showImage]="true"
      />
    </div>
    } @if (!loading) { @for (ticket of tickets; track ticket) {
    <app-sold-ticket-card
      [ticket]="ticket"
      [onTicketDeleted]="onTicketDeleted"
    />
    } } @else {
    <app-sold-report-ticket-skeleton [count]="5" />
    }
  </div>
</div>
